<template>
	<div class="con">
		<div>
			<van-divider dashed class="head-title">{{ksmc}}共有<span>{{list.length}}</span>名医生</van-divider>
		</div>
		<div class="list" v-if="list.length != ''">
			<div v-for="(item,index) in list" class="list-disp" @click="toDeta(index)">
				<img v-if="item.HEAD_PORTRAIT_URL == '' || item.HEAD_PORTRAIT_URL == undefined" class="list-left-img" src="../assets/doctor.png"  />
				<img v-else :src="item.HEAD_PORTRAIT_URL" />
				<div class="list-right">
					<div class="list-name-disp">
						<div class="text">{{item.YGXM}}</div>
						<span>可咨询</span>
					</div>

					<div class="list-right-have">{{item.YGJB}}</div>
					<!--<div class="list-right-have"><span>{{item.accepts}}</span>次接诊</div>-->
				</div>
			</div>
		</div>
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">没有医生~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'communicationList',
		data() {
			return {
				msg: '通讯录',
				showIndex: 0,
				ksmc: '', //科室名
				list: [],
				noImgShow: false,
			}
		},
		methods: {
			//获取科室医生列表
			GetGyYgdmKsdm(ksdm, mzks) {
				this.$store.commit('Load', true)
				this.$Axios.Get('/collect/getGyYgdmKsdm?ksdm=' + ksdm + '&mzks=' + mzks, null).then(data => {
					this.$store.commit('Load', false)
					console.log(data)
					if(data.code == 0) {
						if(data.msg.length != 0) {
							for(let i = 0, len = data.msg.length; i < len; i++) {
								data.msg[i].accepts = 10;
							}
							this.list = data.msg;
						} else {
							this.noImgShow = true;
						}
					} else {
						this.noImgShow = true;
					}

				}).catch(err => {
					this.noImgShow = true;
					this.$store.commit('Load', false)
					console.log(err)
				})
			},
			//医生详情
			toDeta(e) {
				console.log(e)
				let list = JSON.stringify(this.list[e]);
				this.$router.push({
					path: '/communicationDeta',
					query: {
						list: list
					}
				})
			},
		},
		mounted() {
			this.GetGyYgdmKsdm(this.$route.query.ksdm, this.$route.query.mzks);
			this.ksmc = this.$route.query.ksmc;
		}
	}
</script>

<style scoped>
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
	
	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}
	
	.head-title {
		font-size: 16px;
	}
	
	.head-title span {
		color: #27BEC4;
		font-size: 18px;
		font-weight: 700;
	}
	
	.list {
		flex: 1;
		overflow-y: auto;
	}
	
	.list-left-img {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		overflow: hidden;
	}
	
	.list-disp {
		display: flex;
		align-items: center;
		background-color: #fff;
		padding: 15px 10px;
		margin: 0 10px;
		border-bottom: 1px solid #ccc;
	}
	.text{
		color: #000000;
	}
	.list-disp img {
		width: 60px;
		height: 60px;
		border-radius: 50%;
	}
	
	.list-right {
		margin-left: 10px;
		width: 80%;
		font-size: 15px;
		font-weight: 700;
	}
	
	.list-right-have {
		margin-top: 5px;
		color: #999;
		font-weight: 500;
	}
	
	.list-right-have span {
		font-weight: 700;
		color: #000000;
	}
	
	.list-name-disp {
		display: flex;
		justify-content: space-between;
	}
	
	.list-name-disp span {
		font-size: 12px;
		color: #999;
	}
</style>